import { onCLS, onFCP, onLCP, onTTFB, onINP, type Metric } from 'web-vitals';
import { logger } from '@/utils/logger';
import { reportWebVital } from '@/lib/telemetry';

type MetricHandler = (metric: Metric) => void;

/**
 * Reports Core Web Vitals metrics — sends to our own telemetry endpoint
 * (consent-gated inside reportWebVital) and logs in dev.
 */
export const reportWebVitals = (onReport?: MetricHandler) => {
  const handler: MetricHandler = onReport || ((metric) => {
    logger.info(`[Web Vitals] ${metric.name}: ${metric.value.toFixed(2)} ${metric.rating}`);
    if (metric.name === 'CLS' || metric.name === 'FCP' || metric.name === 'LCP' ||
        metric.name === 'TTFB' || metric.name === 'INP') {
      reportWebVital({ name: metric.name, value: metric.value, rating: metric.rating });
    }
  });

  onCLS(handler);
  onFCP(handler);
  onLCP(handler);
  onTTFB(handler);
  onINP(handler);
};
